import store from '@/store'

export default [
  {
    path: '/fee-types',
    name: 'fee-type',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-type/index.vue')
  },
  {
    path: '/fee-types/:id',
    name: 'fee-type-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-type/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('feeType/find', to.params.id)
      next()
    }
  }
]
